import React from 'react';
import { motion } from 'framer-motion';
interface NumberLineProps {
  start: number;
  end: number;
  highlight?: number[];
  label?: string;
}
export function NumberLine({
  start,
  end,
  highlight = [],
  label
}: NumberLineProps) {
  const range = end - start;
  const steps = Math.min(range, 10);
  const stepSize = range / steps;
  return <div className="bg-slate-50 p-6 rounded-xl border border-slate-100" data-id="element-1215">
      {label && <div className="text-sm font-medium text-slate-700 mb-4 text-center" data-id="element-1216">
          {label}
        </div>}
      <div className="relative h-20" data-id="element-1217">
        {/* Line */}
        <div className="absolute top-1/2 left-0 right-0 h-1 bg-slate-300 rounded-full" data-id="element-1218" />

        {/* Markers */}
        {Array.from({
        length: steps + 1
      }).map((_, i) => {
        const value = start + i * stepSize;
        const isHighlighted = highlight.includes(value);
        const position = i / steps * 100;
        return <motion.div key={i} initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: i * 0.1
        }} className="absolute top-1/2 -translate-y-1/2" style={{
          left: `${position}%`
        }} data-id="element-1219">
              <div className={`w-3 h-3 rounded-full -translate-x-1/2 ${isHighlighted ? 'bg-indigo-600 ring-4 ring-indigo-200' : 'bg-slate-400'}`} data-id="element-1220" />
              <div className="absolute top-6 left-1/2 -translate-x-1/2 text-xs font-medium text-slate-700 whitespace-nowrap" data-id="element-1221">
                {value}
              </div>
            </motion.div>;
      })}
      </div>
    </div>;
}